var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrow = function SvgArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 195,
    viewBox: "0 0 53 195",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4151 0.542177C50.2565 -0.173483 51.5187 -0.0715754 52.2344 0.769795C52.95 1.61116 52.8481 2.87339 52.0068 3.58905L49.4151 0.542177ZM41.9638 193.011C41.7545 194.096 40.7057 194.805 39.6211 194.596L21.9471 191.186C20.8625 190.977 20.1529 189.928 20.3622 188.843C20.5714 187.759 21.6203 187.049 22.7049 187.259L38.4151 190.29L41.4463 174.58C41.6555 173.495 42.7044 172.785 43.789 172.995C44.8735 173.204 45.5831 174.253 45.3739 175.337L41.9638 193.011ZM52.0068 3.58905C15.1792 34.9142 2.82826 67.186 4.41597 98.8007C6.01155 130.572 21.6963 162.008 41.6565 191.512L38.3435 193.753C18.2592 164.066 2.07234 131.883 0.421006 99.0013C-1.2382 65.9628 11.7886 32.5469 49.4151 0.542177L52.0068 3.58905Z",
    fill: "#609D76"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Arrow.c88037f7de0272cea6ebabd9dbfb2365.svg";